<template>
  <v-card
    :outlined="border"
    :elevation="border ? 2 : 0"
  >
    <v-card-title v-if="label">{{ label }}</v-card-title>
    <v-row>
      <v-col cols="12">
        <v-tabs
          v-model="mode"
          fixed-tabs
          class="designer-mode-tabs"
          background-color="transparent"
          color="primary"
          slider-color="primary"
        >
          <v-tab>
            <v-icon class="mr-2">mdi-image-edit-outline</v-icon>
            designer
          </v-tab>
          <v-tab>
            <v-icon class="mr-2">mdi-code-tags</v-icon>
            code
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row v-if="emitChange">
      <v-col cols="12" md="6" offset-md="3">
        <v-row>
          <v-col cols="6">
            <v-btn
              @click="emitModifiche"
              color="success"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-floppy</v-icon>
              Salva modifiche
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="annullaModifiche(value)"
              color="warning"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-undo</v-icon>
              Annulla modifiche
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div
      v-if="mode === 0"
      class="d-flex flex-row flex-wrap mb-6 html-designer-layout"
    >
      <div class="html-designer-canvas-box">
        <div
          ref="html_designer_htmlContainer"
          :style="{
            position: 'relative',
            outline: 'thin solid black',
            width: this.canvasX + 'px',
            height: this.canvasY + 'px',
            margin: '0px !important',
            padding: '0px !important'
          }"
        >
          <div
            :style="containerStyle"
            :canvasX="canvasXcss"
            :canvasY="canvasYcss"
            :format="data_format"
            :orientation="data_orientation"
            :jsonProps="encode({ type: 'background' })"
            v-if="template.elements"
            class="drop-zone"
            ref="html_designer_dropZone"
            @drop="onDrop($event)"
            @dragover.prevent
            @dragenter.prevent
          >
            <interact
              v-for="item in template.elements"
              :jsonProps="encode(item)"
              :key="item.id"
              :id="item.id"
              draggable
              resizable
              :dragOption="dragOption"
              :resizeOption="resizeOption"
              v-on:click.native="selected = item"
              :class="'resize-drag resize-drag-' + item.type"
              :style="elementStyle(item)"
              @dragmove="dragMove"
              @dragend="emitChange = true"
              @resizemove="resizemove"
              @resizeend="emitChange = true"
            >
              <div
                v-if="selected && selected.id === item.id"
                class="canvas-delete-btn"
                @click.stop="deleteItemById(item.id)"
                @mousedown.stop
              >
                <v-icon class="canvas-delete-icon" color="error">mdi-close-circle</v-icon>
              </div>
              <div
                v-html="
                  item.type === 'image'
                    ? ''
                    : item.type === 'editable_text'
                    ? item.value
                    : '{{' + item.value + '}}'
                "
              ></div>
            </interact>
          </div>
        </div>
      </div>

      <div class="html-designer-controls-box">
        <v-card outlined class="designer-section-card">
          <v-card-title class="py-2 px-3 text-subtitle-1 font-weight-medium">Azioni E Layout</v-card-title>
          <v-card-text class="pt-2">
            <v-row v-if="editableFormat">
              <v-col cols="12" md="4">
                <v-switch
                  v-model="usePresetFormat"
                  label="Formato predefinito"
                ></v-switch>
              </v-col>
              <template v-if="usePresetFormat">
                <v-col cols="6" md="4">
                  <v-select
                    v-model="data_format"
                    :items="['A7', 'A6', 'A5', 'A4']"
                    label="Formato"
                  ></v-select>
                </v-col>
                <v-col cols="6" md="4">
                  <v-select
                    v-model="data_orientation"
                    :items="['landscape', 'portrait']"
                    label="Orientamento"
                  ></v-select>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model.number="customCanvasX"
                    type="number"
                    label="canvasX"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="4">
                  <v-text-field
                    v-model.number="customCanvasY"
                    type="number"
                    label="canvasY"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </template>
            </v-row>

            <v-row v-if="!selected">
              <v-col cols="6">
                <v-btn
                  @click="$refs.inputUpload.click()"
                  color="primary"
                  class="mr-2"
                  style="width: 100%"
                >
                  <v-icon
                    left
                    color="white"
                  >mdi-upload</v-icon>
                  Carica sfondo
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="addText"
                  color="primary"
                  class="mr-2"
                  style="width: 100%"
                >
                  <v-icon
                    left
                    color="white"
                  >mdi-lead-pencil</v-icon>
                  Aggiungi testo
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="clearSfondo"
                  color="warning"
                  class="mr-2"
                  style="width: 100%"
                >
                  <v-icon
                    left
                    color="white"
                  >mdi-trash-can</v-icon>
                  Cancella sfondo
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="clearAll"
                  color="error"
                  class="mr-2"
                  style="width: 100%"
                >
                  <v-icon
                    left
                    color="white"
                  >mdi-trash-can</v-icon>
                  Cancella tutto
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card v-if="selected" outlined class="designer-section-card selected-detail-card">
          <v-card-title class="py-2 px-3 text-subtitle-1 font-weight-medium">Dettaglio Campo Selezionato</v-card-title>
          <v-card-text class="pt-2">
            <div
              class="selected-detail-close-btn"
              @click="selected = null"
            >
              <v-icon class="selected-detail-close-icon" color="error">mdi-close-circle</v-icon>
            </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Tipo</td>
                    <td>{{ selected.type }}</td>

                    <td>ID</td>
                    <td>{{ selected.id }}</td>
                  </tr>
                  <tr v-if="selected.type === 'editable_text'">
                    <td>Valore</td>
                    <td colspan="3">
                      <v-text-field
                        v-model="selected.value"
                        @change="emitChange = true"
                        hide-details="auto"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr v-else>
                    <td>Descrizione</td>
                    <td colspan="3">{{ selected.dex }}</td>
                  </tr>
                  <tr v-if="selected.type === 'text' || selected.type === 'editable_text'">
                    <td>Font</td>
                    <td>

                      <v-autocomplete
                        v-model="selected.fontFamily"
                        @change="emitChange = true"
                        clearable
                        :items="listFont"
                        item-value="value"
                        item-text="text"
                      >
                        <template v-slot:item="data">

                          <span :style="'font-family: '+data.item.value">
                            {{ data.item.text }}</span>

                        </template>
                      </v-autocomplete>
                    </td>
                    <td>Dimensione</td>
                    <td>
                      <v-text-field
                        v-model="selected.fontSize"
                        @change="emitChange = true"
                        hide-details
                        single-line
                        type="number"
                      />
                    </td>
                  </tr>
                  <tr v-if="selected.type === 'text'">
                    <td>Allineamento</td>
                    <td>
                      <v-select
                        v-model="selected.textAlign"
                        @change="emitChange = true"
                        :items="['', 'left', 'center', 'right', 'justify']"
                        label="Allineamento"
                      ></v-select>
                    </td>

                    <td>Peso</td>
                    <td>
                      <v-select
                        v-model="selected.fontWeight"
                        @change="emitChange = true"
                        :items="['', 'lighter', 'normal', 'bold']"
                        label="Stile"
                      ></v-select>
                    </td>
                  </tr>

                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <v-card outlined class="designer-section-card">
          <v-card-title class="py-2 px-3 text-subtitle-1 font-weight-medium">Campi Trascinabili</v-card-title>
          <v-card-text class="pt-2">
            <div class="draggable-fields-wrap">
              <v-tooltip
                top
                v-for="item in selectableFieldComp"
                :key="item.id"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    :jsonProps="encode(item)"
                    :id="item.id"
                    draggable
                    class="resize-drag movable-drag selectable-field-item"
                    @dragstart="startDrag($event, item)"
                    v-bind="attrs"
                    v-on="on"
                    v-html="'<b>{{' + item.value + '}}</b><br/>' + item.dex"
                  ></div>
                </template>
                <div v-html="'<b>{{' + item.value + '}}</b><br/>' + item.dex"></div>
              </v-tooltip>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-row v-if="mode === 1">
      <v-col cols="12">
        <my-html-editor v-model="rawHTML" />
      </v-col>
    </v-row>
    <input
      v-show="false"
      accept="image/*"
      ref="inputUpload"
      type="file"
      @click="resetFileUploader"
      @change="onFileChange"
    />

    <v-dialog
      v-model="backgroundEditorDialog"
      max-width="1100"
      persistent
    >
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <span>Modifica sfondo</span>
          <v-btn
            icon
            @click="closeBackgroundEditor"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex justify-center mb-4">
            <div class="canvas-upload-frame">
              <div class="background-croppa-scroll">
                <croppa
                  :key="backgroundCroppaKey"
                  v-model="backgroundCroppa"
                  :initial-image="backgroundEditorImage"
                  :prevent-white-space="true"
                  :width="backgroundCanvasWidth"
                  :height="backgroundCanvasHeight"
                  placeholder="Trascina l'immagine"
                  placeholder-color="#999999"
                  :placeholder-font-size="14"
                  canvas-color="transparent"
                  :show-remove-button="false"
                  :show-loading="true"
                  :loading-size="50"
                />
              </div>
            </div>
          </div>

          <v-row class="background-editor-actions">
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                block
                @click="chooseBackgroundFile"
              >
                <v-icon left>mdi-cloud-upload</v-icon>
                Carica
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="secondary"
                block
                @click="zoomBackgroundIn"
              >
                <v-icon left>mdi-magnify-plus-outline</v-icon>
                Zoom +
              </v-btn>
            </v-col> 
            <v-col cols="12" md="2">
              <v-btn
                color="secondary"
                block
                @click="zoomBackgroundOut"
              >
                <v-icon left>mdi-magnify-minus-outline</v-icon>
                Zoom -
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="secondary"
                block
                @click="rotateBackgroundLeft"
              >
                <v-icon left>mdi-rotate-left</v-icon>
                Ruota -90
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="secondary"
                block
                @click="rotateBackgroundRight"
              >
                <v-icon left>mdi-rotate-right</v-icon>
                Ruota +90
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="secondary"
                block
                @click="flipBackgroundHorizontal"
              >
                <v-icon left>mdi-flip-horizontal</v-icon>
                Specchio H
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="secondary"
                block
                @click="flipBackgroundVertical"
              >
                <v-icon left>mdi-flip-vertical</v-icon>
                Specchio V
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="warning"
                block
                @click="resetBackgroundEditor"
              >
                <v-icon left>mdi-restore</v-icon>
                Reset
              </v-btn>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                color="success"
                block
                @click="applyBackgroundFromEditor"
              >
                <v-icon left>mdi-content-save</v-icon>
                Salva sfondo
              </v-btn>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                color="error"
                block
                @click="closeBackgroundEditor"
              >
                <v-icon left>mdi-close-circle-outline</v-icon>
                Annulla
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import interact from "interactjs";
import VComponent from "./VComponent.vue";
import MyHtmlEditor from "@/components/base/MyHtmlEditor.vue";

export default {
  components: { VComponent, MyHtmlEditor },
  name: "html-designer",
  props: {
    componentKey: {
      type: String,
      default: "html_designer",
    },
    value: null,
    label: null,
    border: true,
    editableFormat: {
      type: Boolean,
      default: false,
    },
    selectableField: {
      type: Array,
      default: function () {
        return new Array();
      },
    },
    format: {
      type: String,
      default: null,
    },
    orientation: {
      type: String,
      default: null,
    },
    position: { type: String, default: "absolute" },
    maxSize: {
      type: Number,
      default: 20,
    },
  },
  data: () => ({
    canvasX: 0,
    canvasY: 0,
    data_format: null,
    data_orientation: null,
    usePresetFormat: true,
    customCanvasX: null,
    customCanvasY: null,
    files: null,
    emitChange: false,
    mode: 0,
    selected: null,
    rawHTML: "",
    selectableFieldFixed: [],
    template: { background: null, elements: [], loaded: false },
    resizeOption: {
      edges: { left: false, right: true, bottom: true, top: false },
    },
    dragOption: {
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: "parent",
        }),
      ],
    },
    backgroundEditorDialog: false,
    backgroundCroppa: {},
    backgroundEditorImage: null,
    backgroundEditorRenderTick: 0,
    internalRawHtmlUpdate: false,
    suspendDirtyWatchers: false,
  }),
  beforeDestroy() {
    this.template = { background: null, elements: [], loaded: false };
  },
  mounted() {
    this.data_format = this.format ? this.format : "A5";
    this.data_orientation = this.orientation ? this.orientation : "landscape";
    this.calcolateCanvas();
    this.customCanvasX = this.canvasX;
    this.customCanvasY = this.canvasY;
    this.parseTemplate(this.value);
    this.selectableFieldFixed = [];
    let x = 0;
    for (let el of this.selectableField) {
      el.id = el.value;
      el.x = 0;
      el.y = 10;
      this.selectableFieldFixed.push(el);
    }
  },
  watch: {
    selectableField: {
      handler: function (newSelected) {
        this.selectableFieldFixed = [];
        for (let el of this.selectableField) {
          el.id = el.value;
          el.x = 0;
          el.y = 10;
          this.selectableFieldFixed.push(el);
        }
      },
      deep: true,
    },
    emitChange: function (newVal, oldVal) {
      this.$emit("change2save", newVal);
    },
    format: function (newVal, oldVal) {
      this.data_format = this.format ? this.format : newVal;
    },
    orientation: function (newVal, oldVal) {
      this.data_orientation = this.orientation ? this.orientation : newVal;
    },
    usePresetFormat: function (newVal, oldVal) {
      if (!newVal) {
        this.customCanvasX = this.canvasX;
        this.customCanvasY = this.canvasY;
      }
      this.calcolateCanvas();
      if (this.suspendDirtyWatchers) return;
      if (oldVal !== null && oldVal !== undefined && oldVal !== newVal) {
        this.syncOutputFromCanvas(true);
      }
    },
    customCanvasX: function (newVal, oldVal) {
      if (!this.usePresetFormat) {
        this.calcolateCanvas();
        if (this.suspendDirtyWatchers) return;
        if (oldVal !== null && oldVal !== undefined && newVal !== oldVal) {
          this.syncOutputFromCanvas(true);
        }
      }
    },
    customCanvasY: function (newVal, oldVal) {
      if (!this.usePresetFormat) {
        this.calcolateCanvas();
        if (this.suspendDirtyWatchers) return;
        if (oldVal !== null && oldVal !== undefined && newVal !== oldVal) {
          this.syncOutputFromCanvas(true);
        }
      }
    },
    data_format: function (newVal, oldVal) {
      if (this.usePresetFormat) {
        this.calcolateCanvas();
        if (this.suspendDirtyWatchers) return;
        if (oldVal !== null && oldVal !== undefined && newVal !== oldVal) {
          this.syncOutputFromCanvas(true);
        }
      }
    },
    data_orientation: function (newVal, oldVal) {
      if (this.usePresetFormat) {
        this.calcolateCanvas();
        if (this.suspendDirtyWatchers) return;
        if (oldVal !== null && oldVal !== undefined && newVal !== oldVal) {
          this.syncOutputFromCanvas(true);
        }
      }
    },
    value: function (newVal, oldVal) {
      if (newVal === this.rawHTML) return;
      this.parseTemplate(newVal);
    },
    rawHTML: {
      handler: function (newSelected) {
        if (this.internalRawHtmlUpdate) return;
        if (newSelected !== this.value) this.emitChange = true;
      },
      deep: true,
    },
  },
  computed: {
    selectableFieldComp() {
      let draggedId = this.template.elements.map((el) => {
        return el.id;
      });
      return this.selectableFieldFixed.filter((el) => {
        return !draggedId.includes(el.id);
      });
    },
    listFont() {
      return window.systemData.supportedFonts.map((el) => {
        return { value: el, text: el };
      });
    },
    canvasYcss() {
      return this.canvasY && this.canvasY > 0 ? this.canvasY + "px" : "100%";
    },
    canvasXcss() {
      return this.canvasX && this.canvasX > 0 ? this.canvasX + "px" : "100%";
    },
    containerStyle() {
      let style = {
        height: this.canvasYcss,
        width: this.canvasXcss,
        margin: "0px !important",
        padding: "0px !important",
      };
      if (this.template && this.template.background) {
        style.backgroundImage = this.template.background;
        style.backgroundSize = "cover";
      }
      return style;
    },
    backgroundCanvasWidth() {
      const width = parseInt(this.canvasX, 10);
      return !isNaN(width) && width > 0 ? width : 1;
    },
    backgroundCanvasHeight() {
      const height = parseInt(this.canvasY, 10);
      return !isNaN(height) && height > 0 ? height : 1;
    },
    backgroundCroppaKey() {
      return `bg-${this.backgroundEditorRenderTick}-${this.backgroundCanvasWidth}x${this.backgroundCanvasHeight}`;
    },
  },

  updated() {
    // kept intentionally empty; output sync is handled explicitly in methods/watchers.
  },
  methods: {
    syncOutputFromCanvas(markChanged = false, emitToParent = false) {
      this.$nextTick(() => {
        if (!this.$refs.html_designer_htmlContainer) return;
        let html =
          "<style>body {margin: 0px !important;}</style>" +
          this.$refs.html_designer_htmlContainer.innerHTML;
        this.internalRawHtmlUpdate = true;
        this.rawHTML = html;
        if (emitToParent) this.$emit("input", html);
        this.$nextTick(() => {
          this.internalRawHtmlUpdate = false;
        });
        if (markChanged) this.emitChange = true;
      });
    },
    annullaModifiche(value) {
      this.parseTemplate(value);
    },
    emitModifiche() {
      if (this.mode === 1) {
        // in modalita' codice il rawHTML digitato e' gia' la sorgente di verita', non va ricostruito dal canvas
        this.parseTemplate(this.rawHTML);
        this.$emit("input", this.rawHTML);
      } else {
        this.syncOutputFromCanvas(false, true);
      }
      this.emitChange = false;
    },
    emitDesignerStateChanged() {
      this.$nextTick(() => {
        this.$emit("designer-state-changed", {
          format: this.data_format,
          orientation: this.data_orientation,
          canvasX: this.canvasX,
          canvasY: this.canvasY,
        });
      });
    },
    getPresetCanvas(format, orientation) {
      const matrix = {
        A7: { landscape: { x: 397, y: 280 }, portrait: { x: 280, y: 397 } },
        A6: { landscape: { x: 559, y: 397 }, portrait: { x: 397, y: 559 } },
        A5: { landscape: { x: 794, y: 559 }, portrait: { x: 559, y: 794 } },
        A4: { landscape: { x: 1123, y: 794 }, portrait: { x: 794, y: 1123 } },
      };
      return matrix[format] && matrix[format][orientation]
        ? matrix[format][orientation]
        : null;
    },
    calcolateCanvas(markChanged = false) {
      if (!this.usePresetFormat) {
        let manualCanvasX = parseInt(this.customCanvasX, 10);
        let manualCanvasY = parseInt(this.customCanvasY, 10);
        this.canvasX = !isNaN(manualCanvasX) && manualCanvasX > 0 ? manualCanvasX : this.canvasX;
        this.canvasY = !isNaN(manualCanvasY) && manualCanvasY > 0 ? manualCanvasY : this.canvasY;
        let _ = this;
        this.template.elements = this.template.elements.filter((el) => {
          return el.x + el.w <= _.canvasX && el.y + el.h <= _.canvasY;
        });
        this.emitDesignerStateChanged();
        if (markChanged) this.syncOutputFromCanvas(true);
        return;
      }

      if (this.data_format === "A7") {
        this.canvasX = this.data_orientation === "landscape" ? 397 : 280;
        this.canvasY = this.data_orientation === "landscape" ? 280 : 397;
      }
      if (this.data_format === "A6") {
        this.canvasX = this.data_orientation === "landscape" ? 559 : 397;
        this.canvasY = this.data_orientation === "landscape" ? 397 : 559;
      }
      if (this.data_format === "A5") {
        this.canvasX = this.data_orientation === "landscape" ? 794 : 559;
        this.canvasY = this.data_orientation === "landscape" ? 559 : 794;
      }
      if (this.data_format === "A4") {
        this.canvasX = this.data_orientation === "landscape" ? 1123 : 794;
        this.canvasY = this.data_orientation === "landscape" ? 794 : 1123;
      }
      // rimuove elementi che escono dal canvas
      let _ = this;
      this.template.elements = this.template.elements.filter((el) => {
        return el.x + el.w <= _.canvasX && el.y + el.h <= _.canvasY;
      });
      this.emitDesignerStateChanged();
      if (markChanged) this.syncOutputFromCanvas(true);
    },
    encode(item) {
      return window.btoa(JSON.stringify(item));
    },
    decode(string) {
      return JSON.parse(window.atob(string));
    },
    addText() {
      let id = this.template.elements.length + 1;
      this.template.elements.push({
        type: "editable_text",
        id: "text_" + id,
        value: "text_" + id,
        dex: "text",
        h: 50,
        w: 200,
        x: 0,
        y: 0,
      });
      this.emitChange = true;
    },
    deleteItem() {
      let _ = this;
      this.template.elements = this.template.elements.filter((el) => {
        return el.id !== _.selected.id;
      });
      this.emitChange = true;
      _.selected = null;
    },
    deleteItemById(id) {
      this.template.elements = this.template.elements.filter((el) => {
        return el.id !== id;
      });
      this.emitChange = true;
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("itemID", item.id);
      let leftOrig = evt.srcElement.getBoundingClientRect().left;
      let topOrig = evt.srcElement.getBoundingClientRect().top;
      let offsetX = evt.clientX - leftOrig;
      let offsetY = evt.clientY - topOrig;
      evt.dataTransfer.setData("offsetX", offsetX);
      evt.dataTransfer.setData("offsetY", offsetY);
    },
    onDrop(evt) {
      let item = evt.dataTransfer.getData("itemID");
      let leftDestination =
        this.$refs.html_designer_dropZone.getBoundingClientRect().left;
      let topDestination =
        this.$refs.html_designer_dropZone.getBoundingClientRect().top;

      let offsetX = evt.dataTransfer.getData("offsetX");
      let offsetY = evt.dataTransfer.getData("offsetY");
      let currentItem = this.selectableFieldFixed.find((el) => {
        return el.id === item;
      });
      this.template.elements.push({
        type: currentItem.type,
        value: currentItem.value,
        id: currentItem.id,
        dex: currentItem.dex,
        h: 50,
        w: 200,
        x: evt.clientX - leftDestination - offsetX,
        y: evt.clientY - topDestination - offsetY,
      });
      this.emitChange = true;
    },
    resetFileUploader() {
      this.$refs.inputUpload.value = null;
    },
    onFileChange(event) {
      let _ = this;
      if (!event.target.files) return;
      else {
        _.openBackgroundEditor(event.target.files[0]);
        event.target.files = null;
      }
    },
    chooseBackgroundFile() {
      if (this.backgroundCroppa && this.backgroundCroppa.chooseFile) {
        this.backgroundCroppa.chooseFile();
      }
    },
    openBackgroundEditor(file) {
      let _ = this;
      if (!file) return;
      let reader = new FileReader();
      reader.onload = (e) => {
        _.backgroundEditorRenderTick += 1;
        _.backgroundEditorImage = e.target.result;
        _.backgroundEditorDialog = true;
      };
      reader.readAsDataURL(file);
    },
    closeBackgroundEditor() {
      this.backgroundEditorDialog = false;
      this.backgroundEditorImage = null;
    },
    resetBackgroundEditor() {
      if (this.backgroundCroppa && this.backgroundCroppa.remove) {
        this.backgroundCroppa.remove();
      }
      if (this.backgroundEditorImage && this.backgroundCroppa && this.backgroundCroppa.refresh) {
        this.$nextTick(() => {
          this.backgroundCroppa.refresh();
        });
      }
    },
    zoomBackgroundIn() {
      if (this.backgroundCroppa && this.backgroundCroppa.zoomIn) {
        this.backgroundCroppa.zoomIn();
      }
    },
    zoomBackgroundOut() {
      if (this.backgroundCroppa && this.backgroundCroppa.zoomOut) {
        this.backgroundCroppa.zoomOut();
      }
    },
    rotateBackgroundLeft() {
      if (this.backgroundCroppa && this.backgroundCroppa.rotate) {
        this.backgroundCroppa.rotate(-1);
      }
    },
    rotateBackgroundRight() {
      if (this.backgroundCroppa && this.backgroundCroppa.rotate) {
        this.backgroundCroppa.rotate(1);
      }
    },
    flipBackgroundHorizontal() {
      if (this.backgroundCroppa && this.backgroundCroppa.flipX) {
        this.backgroundCroppa.flipX();
      }
    },
    flipBackgroundVertical() {
      if (this.backgroundCroppa && this.backgroundCroppa.flipY) {
        this.backgroundCroppa.flipY();
      }
    },
    applyBackgroundFromEditor() {
      if (!this.backgroundCroppa || !this.backgroundCroppa.generateDataUrl) {
        return;
      }
      const dataUrl = this.backgroundCroppa.generateDataUrl("image/png", 0.95);
      if (!dataUrl) return;
      this.template.background = "url('" + dataUrl + "')";
      this.emitChange = true;
      this.closeBackgroundEditor();
    },
    createImage(file) {
      let _ = this;
      let reader = new FileReader();
      //_.template.background = null;
      reader.onload = (e) => {
        _.template.background = "url('" + e.target.result + "')";
        _.emitChange = true;
      };
      if (file) reader.readAsDataURL(file);
    },
    clearAll() {
      this.template = { background: null, elements: [], loaded: false };
      this.emitChange = true;
    },
    clearSfondo() {
      this.template.background = null;
      this.emitChange = true;
    },
    parseTemplate(html) {
      let _ = this;
      _.suspendDirtyWatchers = true;
      _.rawHTML = html;
      _.selected = null;
      let template = { background: null, elements: [], loaded: false };

      if (!html || html === "") {
        template.loaded = true;
        _.emitChange = false;
        _.template = template;
        _.$nextTick(() => {
          _.suspendDirtyWatchers = false;
        });
        return;
      }
      try {
        html = html.replace(
          "<style>body {margin: 0px !important;}</style>",
          ""
        );
        let parsedHtml = new DOMParser().parseFromString(html, "text/html");
        _.mode = 1;
        let parsedFormat = _.data_format;
        let parsedOrientation = _.data_orientation;
        let parsedCanvasX = null;
        let parsedCanvasY = null;

        for (let element of parsedHtml.all) {
          if (element.className === "drop-zone") {
            if (element.attributes.orientation) {
              parsedOrientation = element.attributes.orientation.value;
            }
            if (element.attributes.format) {
              parsedFormat = element.attributes.format.value;
            }

            let canvasXAttr = element.getAttribute("canvasX") || element.getAttribute("canvasx");
            let canvasYAttr = element.getAttribute("canvasY") || element.getAttribute("canvasy");
            let styleWidth = element.style && element.style.width ? element.style.width : null;
            let styleHeight = element.style && element.style.height ? element.style.height : null;
            let parsedX = parseInt(canvasXAttr || styleWidth, 10);
            let parsedY = parseInt(canvasYAttr || styleHeight, 10);
            if (!isNaN(parsedX) && parsedX > 0) parsedCanvasX = parsedX;
            if (!isNaN(parsedY) && parsedY > 0) parsedCanvasY = parsedY;
          }
          if (element.attributes.jsonprops) {
            _.mode = 0;
            let props = _.decode(element.attributes.jsonprops.nodeValue);
            if (props.type === "background") {
              template.background = element.style["background-image"];
            } else {
              template.elements.push(props);
            }
          }
        }

        _.data_format = parsedFormat || _.data_format;
        _.data_orientation = parsedOrientation || _.data_orientation;

        const preset = _.getPresetCanvas(_.data_format, _.data_orientation);
        if (parsedCanvasX && parsedCanvasY) {
          if (preset && preset.x === parsedCanvasX && preset.y === parsedCanvasY) {
            _.usePresetFormat = true;
          } else {
            _.usePresetFormat = false;
            _.customCanvasX = parsedCanvasX;
            _.customCanvasY = parsedCanvasY;
            _.canvasX = parsedCanvasX;
            _.canvasY = parsedCanvasY;
          }
        }

        _.calcolateCanvas(false);
        template.loaded = true;
        _.template = template;
      } catch (e) {
        _.template = template;
      }
      _.emitChange = false;
      _.emitDesignerStateChanged();
      _.$nextTick(() => {
        _.suspendDirtyWatchers = false;
      });
    },
    decodeHtml(text) {
      let entities = {
        amp: "&",
        apos: "'",
        "#x27": "'",
        "#x2F": "/",
        "#39": "'",
        "#47": "/",
        lt: "<",
        gt: ">",
        nbsp: " ",
        quot: '"',
      };
      return text.replace(/&([^;]+);/gm, function (match, entity) {
        return entities[entity] || match;
      });
    },
    elementStyle(item) {
      let style = {
        position: this.position,
        height: `${item.h}px`,
        width: `${item.w}px`,
        top: `${item.y}px`,
        left: `${item.x}px`,
        //transform: `translate(${item.x}px, ${item.y}px)`,
      };

      if (item.type === "image") {
        style.backgroundImage = `url({{${item.value}}})`;
        style.backgroundSize = "contain";
        style.backgroundRepeat = "no-repeat";
      } else {
        style.backgroundColor = "transparent";
        style.lineHeight = "100%";
        if (item.textAlign) style["text-align"] = item.textAlign;
        if (item.fontSize) style["font-size"] = item.fontSize + "px";
        if (item.fontWeight) style["font-weight"] = item.fontWeight;
        if (item.fontFamily) style["font-family"] = item.fontFamily;
      }
      return style;
    },
    elementStyleToAdd() {
      let style = {
        position: `relative`,
        height: `20px`,
        width: `"100%"`,
        marginTop: "10px",
        backgroundColor: this.$vuetify.theme.currentTheme.secondary,
        border: "2px solid " + this.$vuetify.theme.currentTheme.primary,
        lineHeight: "100%",
      };
      return style;
    },
    dragMoveToAdd(event) {
      let id = event.currentTarget.id;
      for (let element of this.selectableFieldFixed) {
        if (element.id === id) {
          element.x = element.x + event.dx;
          element.y = element.y + event.dy;
        }
      }
    },
    dragMove(event) {
      let id = event.currentTarget.id;
      for (let element of this.template.elements) {
        if (element.id === id) {
          element.x += event.dx;
          element.y += event.dy;
        }
      }
    },
    resizemove(event) {
      let id = event.currentTarget.id;
      let left = this.$refs.html_designer_dropZone.getBoundingClientRect().left;
      let right =
        this.$refs.html_designer_dropZone.getBoundingClientRect().right;
      let top = this.$refs.html_designer_dropZone.getBoundingClientRect().top;
      let bottom =
        this.$refs.html_designer_dropZone.getBoundingClientRect().bottom;

      for (let element of this.template.elements) {
        if (element.id === id) {
          element.w = event.rect.width;
          element.h = event.rect.height;
          if (element.h < 10) element.h = 10;

          element.x += event.deltaRect.left;
          element.y += event.deltaRect.top;

          let maxWidth = right - left - element.x;
          let maxHeight = bottom - top - element.y;

          if (element.h > maxHeight) element.h = maxHeight;
          if (element.w > maxWidth) element.w = maxWidth;
        }
      }
    },
    moveToAdd(event) {
      let id = event.currentTarget.id;
      for (let element of this.selectableFieldFixed) {
        if (element.id === id) {
          element.x += event.deltaRect.left;
          element.y += event.deltaRect.top;
        }
      }
    },
  },
};
</script>

<style scoped>
.v-tab {
  max-width: none;
}

.designer-mode-tabs {
  border-radius: 12px;
  padding: 6px;
  background: linear-gradient(90deg, #eef3ff 0%, #f7fbff 100%);
  border: 1px solid rgba(25, 118, 210, 0.25);
}

.designer-mode-tabs::v-deep .v-slide-group__content {
  gap: 8px;
}

.designer-mode-tabs::v-deep .v-tab {
  border-radius: 10px;
  min-height: 40px;
  color: #1f3b66 !important;
  background: rgba(25, 118, 210, 0.12);
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.designer-mode-tabs::v-deep .v-tab.v-tab--active {
  background: #1976d2;
  color: #ffffff !important;
  box-shadow: 0 3px 10px rgba(25, 118, 210, 0.35);
}

.designer-mode-tabs::v-deep .v-tab .v-icon {
  color: inherit !important;
}

.designer-mode-tabs::v-deep .v-tabs-slider-wrapper {
  display: none;
}

.movable-drag {
  margin: 10px;
  width: 200px;
  height: 50px;
  line-height: 25px;
  text-align: center;
  float: left;
}

.html-designer-layout {
  align-items: flex-start;
}

.html-designer-canvas-box {
  flex: 0 1 auto;
  max-width: 100%;
  max-height: 80vh;
  margin-top: 30px;
  overflow: auto;
  padding-right: 16px;
  border: 4px solid rgba(0, 0, 0, 0.42);
  border-radius: 12px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.03);
}

.html-designer-controls-box {
  flex: 1 1 320px;
  min-width: 320px;
  padding: 0 20px 20px 20px;
}

.designer-section-card {
  margin-bottom: 12px;
}

.selected-detail-card {
  position: relative;
}

.selected-detail-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  line-height: 0;
  cursor: pointer;
}

.selected-detail-close-icon {
  font-size: 24px !important;
  text-shadow: 0 0 2px rgba(255, 255, 255, 0.95);
}

.draggable-fields-wrap::after {
  content: "";
  display: block;
  clear: both;
}

.selectable-field-item {
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.resize-drag {
  position: relative;
  isolation: isolate;
  overflow: visible !important;
  box-sizing: border-box;
  /* To prevent interact.js warnings */
  user-select: none;
  -ms-touch-action: none;
  touch-action: none;
  border: 1px solid black !important;
  background-color: white !important;
}

.canvas-delete-btn {
  position: absolute !important;
  top: -14px;
  right: -14px;
  z-index: 2147483647 !important;
  line-height: 0;
  cursor: pointer;
  pointer-events: auto;
}

.canvas-delete-icon {
  font-size: 22px !important;
  text-shadow: 0 0 2px rgba(255, 255, 255, 0.95);
}

.canvas-upload-frame {
  display: inline-block;
  border: 4px solid rgba(0, 0, 0, 0.28);
  border-radius: 12px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.03);
  max-width: 100%;
}

.background-croppa-scroll {
  max-width: 100%;
  overflow: auto;
}

@media (max-width: 959px) {
  .html-designer-layout {
    display: block !important;
  }

  .html-designer-canvas-box {
    width: 100%;
    max-height: 65vh;
    margin-top: 12px;
    padding: 8px;
    padding-right: 8px;
    border-width: 2px;
    -webkit-overflow-scrolling: touch;
  }

  .html-designer-controls-box {
    width: 100%;
    min-width: 0;
    padding: 16px 0 0;
  }

  .movable-drag {
    width: calc(50% - 20px);
    margin: 10px;
  }

  .selected-detail-card::v-deep .v-data-table__wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .selected-detail-card::v-deep table {
    min-width: 520px;
  }

  .background-editor-actions > [class*="col-"] {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .background-croppa-scroll {
    -webkit-overflow-scrolling: touch;
  }
}

.resize-drag-image {
  color: transparent !important;
  background-image: none !important;
  background-color: white !important;
  background: white !important;
  background-size: 10px 10px !important;
  background-image: repeating-linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.54) 0,
    rgba(0, 0, 0, 0.54) 1px,
    white 0,
    white 50%
  ) !important;
}
</style>